"use strict";
module.exports = {
    "breakpoints": {
        "s": 320,
        "m": 672,
        "l": 1056,
        "xl": 1312,
        "2xl": 1584
    },
    "colorbrewer": {
        "qualitative": {
            "accent": {
                "1": {
                    "value": "#7FC97F",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#7FC97F"
                    },
                    "name": "ColorbrewerQualitativeAccent1",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "1"
                    ]
                },
                "2": {
                    "value": "#BEAED4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BEAED4"
                    },
                    "name": "ColorbrewerQualitativeAccent2",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "2"
                    ]
                },
                "3": {
                    "value": "#FDC086",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDC086"
                    },
                    "name": "ColorbrewerQualitativeAccent3",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "3"
                    ]
                },
                "4": {
                    "value": "#FFFF99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF99"
                    },
                    "name": "ColorbrewerQualitativeAccent4",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "4"
                    ]
                },
                "5": {
                    "value": "#376BAE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#376BAE"
                    },
                    "name": "ColorbrewerQualitativeAccent5",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "5"
                    ]
                },
                "6": {
                    "value": "#ED0280",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#ED0280"
                    },
                    "name": "ColorbrewerQualitativeAccent6",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "6"
                    ]
                },
                "7": {
                    "value": "#BF5B17",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BF5B17"
                    },
                    "name": "ColorbrewerQualitativeAccent7",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "7"
                    ]
                },
                "8": {
                    "value": "#666666",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#666666"
                    },
                    "name": "ColorbrewerQualitativeAccent8",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "accent",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "accent",
                        "8"
                    ]
                }
            },
            "dark2": {
                "1": {
                    "value": "#1B9D76",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#1B9D76"
                    },
                    "name": "ColorbrewerQualitativeDark21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#D95F02",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#D95F02"
                    },
                    "name": "ColorbrewerQualitativeDark22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#746FB3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#746FB3"
                    },
                    "name": "ColorbrewerQualitativeDark23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#E7278A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E7278A"
                    },
                    "name": "ColorbrewerQualitativeDark24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#65A41E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#65A41E"
                    },
                    "name": "ColorbrewerQualitativeDark25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#E3A702",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E3A702"
                    },
                    "name": "ColorbrewerQualitativeDark26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#A6761D",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6761D"
                    },
                    "name": "ColorbrewerQualitativeDark27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#666666",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#666666"
                    },
                    "name": "ColorbrewerQualitativeDark28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "dark2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "dark2",
                        "8"
                    ]
                }
            },
            "paired": {
                "1": {
                    "value": "#A6CEE3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6CEE3"
                    },
                    "name": "ColorbrewerQualitativePaired1",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "1"
                    ]
                },
                "2": {
                    "value": "#1E77B3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#1E77B3"
                    },
                    "name": "ColorbrewerQualitativePaired2",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "2"
                    ]
                },
                "3": {
                    "value": "#B2DF8A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B2DF8A"
                    },
                    "name": "ColorbrewerQualitativePaired3",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "3"
                    ]
                },
                "4": {
                    "value": "#34A02C",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#34A02C"
                    },
                    "name": "ColorbrewerQualitativePaired4",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FB9A99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FB9A99"
                    },
                    "name": "ColorbrewerQualitativePaired5",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "5"
                    ]
                },
                "6": {
                    "value": "#E41B1E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E41B1E"
                    },
                    "name": "ColorbrewerQualitativePaired6",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "6"
                    ]
                },
                "7": {
                    "value": "#FDBF6F",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDBF6F"
                    },
                    "name": "ColorbrewerQualitativePaired7",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FF8000",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FF8000"
                    },
                    "name": "ColorbrewerQualitativePaired8",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "8"
                    ]
                },
                "9": {
                    "value": "#CAB2D6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CAB2D6"
                    },
                    "name": "ColorbrewerQualitativePaired9",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "9"
                    ]
                },
                "10": {
                    "value": "#6A3D99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#6A3D99"
                    },
                    "name": "ColorbrewerQualitativePaired10",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "10"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "10"
                    ]
                },
                "11": {
                    "value": "#FFFF99",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF99"
                    },
                    "name": "ColorbrewerQualitativePaired11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "11"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "11"
                    ]
                },
                "12": {
                    "value": "#B35929",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B35929"
                    },
                    "name": "ColorbrewerQualitativePaired12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "paired",
                        "subitem": "12"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "paired",
                        "12"
                    ]
                }
            },
            "pastel1": {
                "1": {
                    "value": "#FBB4AE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FBB4AE"
                    },
                    "name": "ColorbrewerQualitativePastel11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "1"
                    ]
                },
                "2": {
                    "value": "#B3CDE3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3CDE3"
                    },
                    "name": "ColorbrewerQualitativePastel12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "2"
                    ]
                },
                "3": {
                    "value": "#CCEBC5",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CCEBC5"
                    },
                    "name": "ColorbrewerQualitativePastel13",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "3"
                    ]
                },
                "4": {
                    "value": "#DECBE4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#DECBE4"
                    },
                    "name": "ColorbrewerQualitativePastel14",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FED9A6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FED9A6"
                    },
                    "name": "ColorbrewerQualitativePastel15",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFFFCC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFFCC"
                    },
                    "name": "ColorbrewerQualitativePastel16",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "6"
                    ]
                },
                "7": {
                    "value": "#E5D8BD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E5D8BD"
                    },
                    "name": "ColorbrewerQualitativePastel17",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FDDAEC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDDAEC"
                    },
                    "name": "ColorbrewerQualitativePastel18",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "8"
                    ]
                },
                "9": {
                    "value": "#F2F2F2",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F2F2F2"
                    },
                    "name": "ColorbrewerQualitativePastel19",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel1",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel1",
                        "9"
                    ]
                }
            },
            "pastel2": {
                "1": {
                    "value": "#B3E2CD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3E2CD"
                    },
                    "name": "ColorbrewerQualitativePastel21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FDCDAC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDCDAC"
                    },
                    "name": "ColorbrewerQualitativePastel22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#CBD5E8",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CBD5E8"
                    },
                    "name": "ColorbrewerQualitativePastel23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#F4CAE4",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F4CAE4"
                    },
                    "name": "ColorbrewerQualitativePastel24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#E6F5C9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E6F5C9"
                    },
                    "name": "ColorbrewerQualitativePastel25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFF2AE",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFF2AE"
                    },
                    "name": "ColorbrewerQualitativePastel26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#F1E2CC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F1E2CC"
                    },
                    "name": "ColorbrewerQualitativePastel27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#CCCCCC",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CCCCCC"
                    },
                    "name": "ColorbrewerQualitativePastel28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "pastel2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "pastel2",
                        "8"
                    ]
                }
            },
            "set1": {
                "1": {
                    "value": "#E61A1D",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E61A1D"
                    },
                    "name": "ColorbrewerQualitativeSet11",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "1"
                    ]
                },
                "2": {
                    "value": "#377EB9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#377EB9"
                    },
                    "name": "ColorbrewerQualitativeSet12",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "2"
                    ]
                },
                "3": {
                    "value": "#4DB04A",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#4DB04A"
                    },
                    "name": "ColorbrewerQualitativeSet13",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "3"
                    ]
                },
                "4": {
                    "value": "#974EA2",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#974EA2"
                    },
                    "name": "ColorbrewerQualitativeSet14",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "4"
                    ]
                },
                "5": {
                    "value": "#FF8000",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FF8000"
                    },
                    "name": "ColorbrewerQualitativeSet15",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFFF33",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFF33"
                    },
                    "name": "ColorbrewerQualitativeSet16",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "6"
                    ]
                },
                "7": {
                    "value": "#A45528",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A45528"
                    },
                    "name": "ColorbrewerQualitativeSet17",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "7"
                    ]
                },
                "8": {
                    "value": "#F782C1",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#F782C1"
                    },
                    "name": "ColorbrewerQualitativeSet18",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "8"
                    ]
                },
                "9": {
                    "value": "#999999",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#999999"
                    },
                    "name": "ColorbrewerQualitativeSet19",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set1",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set1",
                        "9"
                    ]
                }
            },
            "set2": {
                "1": {
                    "value": "#66C2A5",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#66C2A5"
                    },
                    "name": "ColorbrewerQualitativeSet21",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FC8F64",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FC8F64"
                    },
                    "name": "ColorbrewerQualitativeSet22",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "2"
                    ]
                },
                "3": {
                    "value": "#8C9ECA",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#8C9ECA"
                    },
                    "name": "ColorbrewerQualitativeSet23",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "3"
                    ]
                },
                "4": {
                    "value": "#E788C3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#E788C3"
                    },
                    "name": "ColorbrewerQualitativeSet24",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "4"
                    ]
                },
                "5": {
                    "value": "#A6D855",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#A6D855"
                    },
                    "name": "ColorbrewerQualitativeSet25",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FFD92E",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFD92E"
                    },
                    "name": "ColorbrewerQualitativeSet26",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "6"
                    ]
                },
                "7": {
                    "value": "#FEE8C8",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FEE8C8"
                    },
                    "name": "ColorbrewerQualitativeSet27",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "7"
                    ]
                },
                "8": {
                    "value": "#999999",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#999999"
                    },
                    "name": "ColorbrewerQualitativeSet28",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set2",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set2",
                        "8"
                    ]
                }
            },
            "set3": {
                "1": {
                    "value": "#8DD3C7",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#8DD3C7"
                    },
                    "name": "ColorbrewerQualitativeSet31",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "1"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "1"
                    ]
                },
                "2": {
                    "value": "#FFFFB3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFFFB3"
                    },
                    "name": "ColorbrewerQualitativeSet32",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "2"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "2"
                    ]
                },
                "3": {
                    "value": "#BDB9DA",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BDB9DA"
                    },
                    "name": "ColorbrewerQualitativeSet33",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "3"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "3"
                    ]
                },
                "4": {
                    "value": "#FB8274",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FB8274"
                    },
                    "name": "ColorbrewerQualitativeSet34",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "4"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "4"
                    ]
                },
                "5": {
                    "value": "#7EAFD3",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#7EAFD3"
                    },
                    "name": "ColorbrewerQualitativeSet35",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "5"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "5"
                    ]
                },
                "6": {
                    "value": "#FDB563",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FDB563"
                    },
                    "name": "ColorbrewerQualitativeSet36",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "6"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "6"
                    ]
                },
                "7": {
                    "value": "#B3DE68",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#B3DE68"
                    },
                    "name": "ColorbrewerQualitativeSet37",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "7"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "7"
                    ]
                },
                "8": {
                    "value": "#FCCFE6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FCCFE6"
                    },
                    "name": "ColorbrewerQualitativeSet38",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "8"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "8"
                    ]
                },
                "9": {
                    "value": "#D9D9D9",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#D9D9D9"
                    },
                    "name": "ColorbrewerQualitativeSet39",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "9"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "9"
                    ]
                },
                "10": {
                    "value": "#BC7FBD",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#BC7FBD"
                    },
                    "name": "ColorbrewerQualitativeSet310",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "10"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "10"
                    ]
                },
                "11": {
                    "value": "#CDEBC6",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#CDEBC6"
                    },
                    "name": "ColorbrewerQualitativeSet311",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "11"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "11"
                    ]
                },
                "12": {
                    "value": "#FFEE70",
                    "filePath": "src/foundation/figma/colorbrewer.json",
                    "isSource": true,
                    "original": {
                        "value": "#FFEE70"
                    },
                    "name": "ColorbrewerQualitativeSet312",
                    "attributes": {
                        "category": "colorbrewer",
                        "type": "qualitative",
                        "item": "set3",
                        "subitem": "12"
                    },
                    "path": [
                        "colorbrewer",
                        "qualitative",
                        "set3",
                        "12"
                    ]
                }
            }
        }
    },
    "colors": {
        "active": {
            "100": {
                "value": "#01ffc6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#01ffc6"
                },
                "name": "ColorsActive100",
                "attributes": {
                    "category": "colors",
                    "type": "active",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "active",
                    "100"
                ]
            }
        },
        "black": {
            "100": {
                "value": "#000000",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#000000"
                },
                "name": "ColorsBlack100",
                "attributes": {
                    "category": "colors",
                    "type": "black",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "black",
                    "100"
                ]
            }
        },
        "blue": {
            "100": {
                "value": "#d9f9ff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d9f9ff"
                },
                "name": "ColorsBlue100",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "blue",
                    "100"
                ]
            },
            "150": {
                "value": "#c2f2fd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c2f2fd"
                },
                "name": "ColorsBlue150",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "blue",
                    "150"
                ]
            },
            "200": {
                "value": "#adecfa",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#adecfa"
                },
                "name": "ColorsBlue200",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "blue",
                    "200"
                ]
            },
            "300": {
                "value": "#7fdbf3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#7fdbf3"
                },
                "name": "ColorsBlue300",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "blue",
                    "300"
                ]
            },
            "400": {
                "value": "#54c5e7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#54c5e7"
                },
                "name": "ColorsBlue400",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "blue",
                    "400"
                ]
            },
            "500": {
                "value": "#30abd5",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#30abd5"
                },
                "name": "ColorsBlue500",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "blue",
                    "500"
                ]
            },
            "600": {
                "value": "#168fbb",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#168fbb"
                },
                "name": "ColorsBlue600",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "blue",
                    "600"
                ]
            },
            "700": {
                "value": "#07719c",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#07719c"
                },
                "name": "ColorsBlue700",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "blue",
                    "700"
                ]
            },
            "800": {
                "value": "#01547a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#01547a"
                },
                "name": "ColorsBlue800",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "blue",
                    "800"
                ]
            },
            "850": {
                "value": "#014869",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#014869"
                },
                "name": "ColorsBlue850",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "blue",
                    "850"
                ]
            },
            "900": {
                "value": "#003b59",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#003b59"
                },
                "name": "ColorsBlue900",
                "attributes": {
                    "category": "colors",
                    "type": "blue",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "blue",
                    "900"
                ]
            }
        },
        "cyan": {
            "100": {
                "value": "#dffffd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dffffd"
                },
                "name": "ColorsCyan100",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "cyan",
                    "100"
                ]
            },
            "300": {
                "value": "#a5eeef",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#a5eeef"
                },
                "name": "ColorsCyan300",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "cyan",
                    "300"
                ]
            },
            "500": {
                "value": "#6dcdd8",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#6dcdd8"
                },
                "name": "ColorsCyan500",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "cyan",
                    "500"
                ]
            },
            "700": {
                "value": "#3ba0b7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#3ba0b7"
                },
                "name": "ColorsCyan700",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "cyan",
                    "700"
                ]
            },
            "900": {
                "value": "#147092",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#147092"
                },
                "name": "ColorsCyan900",
                "attributes": {
                    "category": "colors",
                    "type": "cyan",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "cyan",
                    "900"
                ]
            }
        },
        "emerald": {
            "100": {
                "value": "#e6fff7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6fff7"
                },
                "name": "ColorsEmerald100",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "emerald",
                    "100"
                ]
            },
            "150": {
                "value": "#c9f8eb",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c9f8eb"
                },
                "name": "ColorsEmerald150",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "emerald",
                    "150"
                ]
            },
            "200": {
                "value": "#aef1e1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#aef1e1"
                },
                "name": "ColorsEmerald200",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "emerald",
                    "200"
                ]
            },
            "300": {
                "value": "#86ddcf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#86ddcf"
                },
                "name": "ColorsEmerald300",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "emerald",
                    "300"
                ]
            },
            "400": {
                "value": "#5ecabf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#5ecabf"
                },
                "name": "ColorsEmerald400",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "emerald",
                    "400"
                ]
            },
            "500": {
                "value": "#35b7b2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#35b7b2"
                },
                "name": "ColorsEmerald500",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "emerald",
                    "500"
                ]
            },
            "600": {
                "value": "#0da1a4",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#0da1a4"
                },
                "name": "ColorsEmerald600",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "emerald",
                    "600"
                ]
            },
            "700": {
                "value": "#038185",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#038185"
                },
                "name": "ColorsEmerald700",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "emerald",
                    "700"
                ]
            },
            "800": {
                "value": "#006266",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#006266"
                },
                "name": "ColorsEmerald800",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "emerald",
                    "800"
                ]
            },
            "850": {
                "value": "#005153",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#005153"
                },
                "name": "ColorsEmerald850",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "emerald",
                    "850"
                ]
            },
            "900": {
                "value": "#003f40",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#003f40"
                },
                "name": "ColorsEmerald900",
                "attributes": {
                    "category": "colors",
                    "type": "emerald",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "emerald",
                    "900"
                ]
            }
        },
        "green": {
            "100": {
                "value": "#eaffbf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#eaffbf"
                },
                "name": "ColorsGreen100",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "green",
                    "100"
                ]
            },
            "150": {
                "value": "#e0fdb0",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e0fdb0"
                },
                "name": "ColorsGreen150",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "green",
                    "150"
                ]
            },
            "200": {
                "value": "#d6faa2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d6faa2"
                },
                "name": "ColorsGreen200",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "green",
                    "200"
                ]
            },
            "300": {
                "value": "#bbf383",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#bbf383"
                },
                "name": "ColorsGreen300",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "green",
                    "300"
                ]
            },
            "400": {
                "value": "#9be764",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#9be764"
                },
                "name": "ColorsGreen400",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "green",
                    "400"
                ]
            },
            "500": {
                "value": "#78d549",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#78d549"
                },
                "name": "ColorsGreen500",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "green",
                    "500"
                ]
            },
            "600": {
                "value": "#56bb34",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#56bb34"
                },
                "name": "ColorsGreen600",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "green",
                    "600"
                ]
            },
            "700": {
                "value": "#389c24",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#389c24"
                },
                "name": "ColorsGreen700",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "green",
                    "700"
                ]
            },
            "800": {
                "value": "#217a19",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#217a19"
                },
                "name": "ColorsGreen800",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "green",
                    "800"
                ]
            },
            "850": {
                "value": "#196915",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#196915"
                },
                "name": "ColorsGreen850",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "green",
                    "850"
                ]
            },
            "900": {
                "value": "#125912",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#125912"
                },
                "name": "ColorsGreen900",
                "attributes": {
                    "category": "colors",
                    "type": "green",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "green",
                    "900"
                ]
            }
        },
        "indigo": {
            "100": {
                "value": "#e6dfff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6dfff"
                },
                "name": "ColorsIndigo100",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "indigo",
                    "100"
                ]
            },
            "300": {
                "value": "#b3a2f1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b3a2f1"
                },
                "name": "ColorsIndigo300",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "indigo",
                    "300"
                ]
            },
            "500": {
                "value": "#7d64d6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#7d64d6"
                },
                "name": "ColorsIndigo500",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "indigo",
                    "500"
                ]
            },
            "700": {
                "value": "#472ca6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#472ca6"
                },
                "name": "ColorsIndigo700",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "indigo",
                    "700"
                ]
            },
            "900": {
                "value": "#1e076e",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#1e076e"
                },
                "name": "ColorsIndigo900",
                "attributes": {
                    "category": "colors",
                    "type": "indigo",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "indigo",
                    "900"
                ]
            }
        },
        "midnight": {
            "100": {
                "value": "#faf9ff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#faf9ff"
                },
                "name": "ColorsMidnight100",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "midnight",
                    "100"
                ]
            },
            "150": {
                "value": "#eceaf1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#eceaf1"
                },
                "name": "ColorsMidnight150",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "midnight",
                    "150"
                ]
            },
            "200": {
                "value": "#dedce4",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dedce4"
                },
                "name": "ColorsMidnight200",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "midnight",
                    "200"
                ]
            },
            "300": {
                "value": "#c0bec9",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c0bec9"
                },
                "name": "ColorsMidnight300",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "midnight",
                    "300"
                ]
            },
            "400": {
                "value": "#a29eae",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#a29eae"
                },
                "name": "ColorsMidnight400",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "midnight",
                    "400"
                ]
            },
            "500": {
                "value": "#837e93",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#837e93"
                },
                "name": "ColorsMidnight500",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "midnight",
                    "500"
                ]
            },
            "600": {
                "value": "#676178",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#676178"
                },
                "name": "ColorsMidnight600",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "midnight",
                    "600"
                ]
            },
            "700": {
                "value": "#4d485c",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#4d485c"
                },
                "name": "ColorsMidnight700",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "midnight",
                    "700"
                ]
            },
            "800": {
                "value": "#353241",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#353241"
                },
                "name": "ColorsMidnight800",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "midnight",
                    "800"
                ]
            },
            "850": {
                "value": "#2a2734",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#2a2734"
                },
                "name": "ColorsMidnight850",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "midnight",
                    "850"
                ]
            },
            "900": {
                "value": "#1f1d26",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#1f1d26"
                },
                "name": "ColorsMidnight900",
                "attributes": {
                    "category": "colors",
                    "type": "midnight",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "midnight",
                    "900"
                ]
            }
        },
        "mint": {
            "100": {
                "value": "#dffff1",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#dffff1"
                },
                "name": "ColorsMint100",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "mint",
                    "100"
                ]
            },
            "300": {
                "value": "#b3fee3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b3fee3"
                },
                "name": "ColorsMint300",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "mint",
                    "300"
                ]
            },
            "500": {
                "value": "#84f6d6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#84f6d6"
                },
                "name": "ColorsMint500",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "mint",
                    "500"
                ]
            },
            "700": {
                "value": "#53e4c8",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#53e4c8"
                },
                "name": "ColorsMint700",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "mint",
                    "700"
                ]
            },
            "900": {
                "value": "#28cebc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#28cebc"
                },
                "name": "ColorsMint900",
                "attributes": {
                    "category": "colors",
                    "type": "mint",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "mint",
                    "900"
                ]
            }
        },
        "navy": {
            "100": {
                "value": "#e6fcff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6fcff"
                },
                "name": "ColorsNavy100",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "navy",
                    "100"
                ]
            },
            "150": {
                "value": "#cef0f6",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cef0f6"
                },
                "name": "ColorsNavy150",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "navy",
                    "150"
                ]
            },
            "200": {
                "value": "#b7e2ec",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b7e2ec"
                },
                "name": "ColorsNavy200",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "navy",
                    "200"
                ]
            },
            "300": {
                "value": "#8dc3d7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8dc3d7"
                },
                "name": "ColorsNavy300",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "navy",
                    "300"
                ]
            },
            "400": {
                "value": "#69a2c2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#69a2c2"
                },
                "name": "ColorsNavy400",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "navy",
                    "400"
                ]
            },
            "500": {
                "value": "#4981ad",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#4981ad"
                },
                "name": "ColorsNavy500",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "navy",
                    "500"
                ]
            },
            "600": {
                "value": "#2e6197",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#2e6197"
                },
                "name": "ColorsNavy600",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "navy",
                    "600"
                ]
            },
            "700": {
                "value": "#184382",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#184382"
                },
                "name": "ColorsNavy700",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "navy",
                    "700"
                ]
            },
            "800": {
                "value": "#092c64",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#092c64"
                },
                "name": "ColorsNavy800",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "navy",
                    "800"
                ]
            },
            "850": {
                "value": "#042252",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#042252"
                },
                "name": "ColorsNavy850",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "navy",
                    "850"
                ]
            },
            "900": {
                "value": "#001940",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#001940"
                },
                "name": "ColorsNavy900",
                "attributes": {
                    "category": "colors",
                    "type": "navy",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "navy",
                    "900"
                ]
            }
        },
        "purple": {
            "100": {
                "value": "#ffdfec",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffdfec"
                },
                "name": "ColorsPurple100",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "purple",
                    "100"
                ]
            },
            "300": {
                "value": "#f9b7d7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f9b7d7"
                },
                "name": "ColorsPurple300",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "purple",
                    "300"
                ]
            },
            "500": {
                "value": "#ec8cc2",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ec8cc2"
                },
                "name": "ColorsPurple500",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "purple",
                    "500"
                ]
            },
            "700": {
                "value": "#d460ac",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d460ac"
                },
                "name": "ColorsPurple700",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "purple",
                    "700"
                ]
            },
            "900": {
                "value": "#b93a98",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b93a98"
                },
                "name": "ColorsPurple900",
                "attributes": {
                    "category": "colors",
                    "type": "purple",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "purple",
                    "900"
                ]
            }
        },
        "red": {
            "100": {
                "value": "#ffe2d3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffe2d3"
                },
                "name": "ColorsRed100",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "red",
                    "100"
                ]
            },
            "150": {
                "value": "#fdd1bd",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fdd1bd"
                },
                "name": "ColorsRed150",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "red",
                    "150"
                ]
            },
            "200": {
                "value": "#fcc0a7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fcc0a7"
                },
                "name": "ColorsRed200",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "red",
                    "200"
                ]
            },
            "300": {
                "value": "#f6997a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f6997a"
                },
                "name": "ColorsRed300",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "red",
                    "300"
                ]
            },
            "400": {
                "value": "#ec704f",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ec704f"
                },
                "name": "ColorsRed400",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "red",
                    "400"
                ]
            },
            "500": {
                "value": "#de492b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#de492b"
                },
                "name": "ColorsRed500",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "red",
                    "500"
                ]
            },
            "600": {
                "value": "#cb2811",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cb2811"
                },
                "name": "ColorsRed600",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "red",
                    "600"
                ]
            },
            "700": {
                "value": "#b31102",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b31102"
                },
                "name": "ColorsRed700",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "red",
                    "700"
                ]
            },
            "800": {
                "value": "#980600",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#980600"
                },
                "name": "ColorsRed800",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "red",
                    "800"
                ]
            },
            "850": {
                "value": "#8c0300",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8c0300"
                },
                "name": "ColorsRed850",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "red",
                    "850"
                ]
            },
            "900": {
                "value": "#800000",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#800000"
                },
                "name": "ColorsRed900",
                "attributes": {
                    "category": "colors",
                    "type": "red",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "red",
                    "900"
                ]
            }
        },
        "sand": {
            "100": {
                "value": "#f8f7f3",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f8f7f3"
                },
                "name": "ColorsSand100",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "sand",
                    "100"
                ]
            },
            "150": {
                "value": "#ebe8df",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ebe8df"
                },
                "name": "ColorsSand150",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "sand",
                    "150"
                ]
            },
            "200": {
                "value": "#ded9cc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ded9cc"
                },
                "name": "ColorsSand200",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "sand",
                    "200"
                ]
            },
            "300": {
                "value": "#c4b9a7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#c4b9a7"
                },
                "name": "ColorsSand300",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "sand",
                    "300"
                ]
            },
            "400": {
                "value": "#aa9987",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#aa9987"
                },
                "name": "ColorsSand400",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "sand",
                    "400"
                ]
            },
            "500": {
                "value": "#8f7a6a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8f7a6a"
                },
                "name": "ColorsSand500",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "sand",
                    "500"
                ]
            },
            "600": {
                "value": "#755d52",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#755d52"
                },
                "name": "ColorsSand600",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "sand",
                    "600"
                ]
            },
            "700": {
                "value": "#5a443d",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#5a443d"
                },
                "name": "ColorsSand700",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "sand",
                    "700"
                ]
            },
            "800": {
                "value": "#402d2a",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#402d2a"
                },
                "name": "ColorsSand800",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "sand",
                    "800"
                ]
            },
            "850": {
                "value": "#332321",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#332321"
                },
                "name": "ColorsSand850",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "sand",
                    "850"
                ]
            },
            "900": {
                "value": "#261a19",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#261a19"
                },
                "name": "ColorsSand900",
                "attributes": {
                    "category": "colors",
                    "type": "sand",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "sand",
                    "900"
                ]
            }
        },
        "sun": {
            "100": {
                "value": "#fff8df",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fff8df"
                },
                "name": "ColorsSun100",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "sun",
                    "100"
                ]
            },
            "300": {
                "value": "#fff3bc",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fff3bc"
                },
                "name": "ColorsSun300",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "sun",
                    "300"
                ]
            },
            "500": {
                "value": "#f8eb95",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f8eb95"
                },
                "name": "ColorsSun500",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "sun",
                    "500"
                ]
            },
            "700": {
                "value": "#e6dc6b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#e6dc6b"
                },
                "name": "ColorsSun700",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "sun",
                    "700"
                ]
            },
            "900": {
                "value": "#d1cb44",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#d1cb44"
                },
                "name": "ColorsSun900",
                "attributes": {
                    "category": "colors",
                    "type": "sun",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "sun",
                    "900"
                ]
            }
        },
        "white": {
            "100": {
                "value": "#ffffff",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffffff"
                },
                "name": "ColorsWhite100",
                "attributes": {
                    "category": "colors",
                    "type": "white",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "white",
                    "100"
                ]
            }
        },
        "yellow": {
            "100": {
                "value": "#ffefcf",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ffefcf"
                },
                "name": "ColorsYellow100",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "100"
                },
                "path": [
                    "colors",
                    "yellow",
                    "100"
                ]
            },
            "150": {
                "value": "#fde6b7",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fde6b7"
                },
                "name": "ColorsYellow150",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "150"
                },
                "path": [
                    "colors",
                    "yellow",
                    "150"
                ]
            },
            "200": {
                "value": "#fcdda0",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#fcdda0"
                },
                "name": "ColorsYellow200",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "200"
                },
                "path": [
                    "colors",
                    "yellow",
                    "200"
                ]
            },
            "300": {
                "value": "#f6c96f",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#f6c96f"
                },
                "name": "ColorsYellow300",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "300"
                },
                "path": [
                    "colors",
                    "yellow",
                    "300"
                ]
            },
            "400": {
                "value": "#ecb341",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#ecb341"
                },
                "name": "ColorsYellow400",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "400"
                },
                "path": [
                    "colors",
                    "yellow",
                    "400"
                ]
            },
            "500": {
                "value": "#de9d1b",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#de9d1b"
                },
                "name": "ColorsYellow500",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "500"
                },
                "path": [
                    "colors",
                    "yellow",
                    "500"
                ]
            },
            "600": {
                "value": "#cb8801",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#cb8801"
                },
                "name": "ColorsYellow600",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "600"
                },
                "path": [
                    "colors",
                    "yellow",
                    "600"
                ]
            },
            "700": {
                "value": "#b37700",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#b37700"
                },
                "name": "ColorsYellow700",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "700"
                },
                "path": [
                    "colors",
                    "yellow",
                    "700"
                ]
            },
            "800": {
                "value": "#986600",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#986600"
                },
                "name": "ColorsYellow800",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "800"
                },
                "path": [
                    "colors",
                    "yellow",
                    "800"
                ]
            },
            "850": {
                "value": "#8c5d00",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#8c5d00"
                },
                "name": "ColorsYellow850",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "850"
                },
                "path": [
                    "colors",
                    "yellow",
                    "850"
                ]
            },
            "900": {
                "value": "#805500",
                "filePath": "src/foundation/figma/colors.json",
                "isSource": true,
                "original": {
                    "value": "#805500"
                },
                "name": "ColorsYellow900",
                "attributes": {
                    "category": "colors",
                    "type": "yellow",
                    "item": "900"
                },
                "path": [
                    "colors",
                    "yellow",
                    "900"
                ]
            }
        }
    },
    "radius": {
        "s": "4px",
        "m": "8px",
        "lg": "16px"
    },
    "shadows": {
        "light": {
            "inner": {
                "value": "1.51px 1.51px 1.51px 261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "1.51px 1.51px 1.51px 261a191a"
                },
                "name": "ShadowsLightInner",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "inner"
                },
                "path": [
                    "shadows",
                    "light",
                    "inner"
                ]
            },
            "s": {
                "value": "0px 0.76px 2.27px #261a191a, 0px 0.76px 1.51px #261a190f",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 0.76px 2.27px #261a191a, 0px 0.76px 1.51px #261a190f"
                },
                "name": "ShadowsLightS",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "s"
                },
                "path": [
                    "shadows",
                    "light",
                    "s"
                ]
            },
            "m": {
                "value": "0px 3.03px 4.54px #261a190d, 0px 1.51px 5.3px #261a190a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a190d, 0px 1.51px 5.3px #261a190a"
                },
                "name": "ShadowsLightM",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "m"
                },
                "path": [
                    "shadows",
                    "light",
                    "m"
                ]
            },
            "l": {
                "value": "0px 3.03px 4.54px #261a190d, 0px 7.57px 11.35px #261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a190d, 0px 7.57px 11.35px #261a191a"
                },
                "name": "ShadowsLightL",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "l"
                },
                "path": [
                    "shadows",
                    "light",
                    "l"
                ]
            },
            "xl": {
                "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a191a",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a191a"
                },
                "name": "ShadowsLightXl",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "xl"
                },
                "path": [
                    "shadows",
                    "light",
                    "xl"
                ]
            },
            "2xl": {
                "value": "0px 18.92px 37.84px #261a1940",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 18.92px 37.84px #261a1940"
                },
                "name": "ShadowsLight2xl",
                "attributes": {
                    "category": "shadows",
                    "type": "light",
                    "item": "2xl"
                },
                "path": [
                    "shadows",
                    "light",
                    "2xl"
                ]
            }
        },
        "dark": {
            "inner": {
                "value": "1.51px 1.51px 1.51px #00000080",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "1.51px 1.51px 1.51px #00000080"
                },
                "name": "ShadowsDarkInner",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "inner"
                },
                "path": [
                    "shadows",
                    "dark",
                    "inner"
                ]
            },
            "s": {
                "value": "0px 0.76px 2.27px #261a19, 0px 0.76px 1.51px #261a19bf",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 0.76px 2.27px #261a19, 0px 0.76px 1.51px #261a19bf"
                },
                "name": "ShadowsDarkS",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "s"
                },
                "path": [
                    "shadows",
                    "dark",
                    "s"
                ]
            },
            "m": {
                "value": "0px 3.03px 4.54px #261a19, 0px 1.51px 5.3px #261a19bf",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a19, 0px 1.51px 5.3px #261a19bf"
                },
                "name": "ShadowsDarkM",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "m"
                },
                "path": [
                    "shadows",
                    "dark",
                    "m"
                ]
            },
            "l": {
                "value": "0px 3.03px 4.54px #261a19, 0px 7.57px 11.25px #261a1980",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 3.03px 4.54px #261a19, 0px 7.57px 11.25px #261a1980"
                },
                "name": "ShadowsDarkL",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "l"
                },
                "path": [
                    "shadows",
                    "dark",
                    "l"
                ]
            },
            "xl": {
                "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a1980",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 7.57px 7.57px #261a190a, 0px 15.14px 18.92px #261a1980"
                },
                "name": "ShadowsDarkXl",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "xl"
                },
                "path": [
                    "shadows",
                    "dark",
                    "xl"
                ]
            },
            "2xl": {
                "value": "0px 18.92px 37.84px #00000080",
                "filePath": "src/foundation/figma/shadows.json",
                "isSource": true,
                "original": {
                    "value": "0px 18.92px 37.84px #00000080"
                },
                "name": "ShadowsDark2xl",
                "attributes": {
                    "category": "shadows",
                    "type": "dark",
                    "item": "2xl"
                },
                "path": [
                    "shadows",
                    "dark",
                    "2xl"
                ]
            }
        }
    },
    "spacing": {
        "2xs": {
            "value": "2px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "2px"
            },
            "name": "Spacing2xs",
            "attributes": {
                "category": "spacing",
                "type": "2xs"
            },
            "path": [
                "spacing",
                "2xs"
            ]
        },
        "xs": {
            "value": "4px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "4px"
            },
            "name": "SpacingXs",
            "attributes": {
                "category": "spacing",
                "type": "xs"
            },
            "path": [
                "spacing",
                "xs"
            ]
        },
        "s": {
            "value": "8px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "8px"
            },
            "name": "SpacingS",
            "attributes": {
                "category": "spacing",
                "type": "s"
            },
            "path": [
                "spacing",
                "s"
            ]
        },
        "m": {
            "value": "12px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "12px"
            },
            "name": "SpacingM",
            "attributes": {
                "category": "spacing",
                "type": "m"
            },
            "path": [
                "spacing",
                "m"
            ]
        },
        "l": {
            "value": "16px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "16px"
            },
            "name": "SpacingL",
            "attributes": {
                "category": "spacing",
                "type": "l"
            },
            "path": [
                "spacing",
                "l"
            ]
        },
        "xl": {
            "value": "20px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "20px"
            },
            "name": "SpacingXl",
            "attributes": {
                "category": "spacing",
                "type": "xl"
            },
            "path": [
                "spacing",
                "xl"
            ]
        },
        "2xl": {
            "value": "24px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "24px"
            },
            "name": "Spacing2xl",
            "attributes": {
                "category": "spacing",
                "type": "2xl"
            },
            "path": [
                "spacing",
                "2xl"
            ]
        },
        "3xl": {
            "value": "32px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "32px"
            },
            "name": "Spacing3xl",
            "attributes": {
                "category": "spacing",
                "type": "3xl"
            },
            "path": [
                "spacing",
                "3xl"
            ]
        },
        "4xl": {
            "value": "40px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "40px"
            },
            "name": "Spacing4xl",
            "attributes": {
                "category": "spacing",
                "type": "4xl"
            },
            "path": [
                "spacing",
                "4xl"
            ]
        },
        "5xl": {
            "value": "48px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "48px"
            },
            "name": "Spacing5xl",
            "attributes": {
                "category": "spacing",
                "type": "5xl"
            },
            "path": [
                "spacing",
                "5xl"
            ]
        },
        "6xl": {
            "value": "64px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "64px"
            },
            "name": "Spacing6xl",
            "attributes": {
                "category": "spacing",
                "type": "6xl"
            },
            "path": [
                "spacing",
                "6xl"
            ]
        },
        "7xl": {
            "value": "96px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "96px"
            },
            "name": "Spacing7xl",
            "attributes": {
                "category": "spacing",
                "type": "7xl"
            },
            "path": [
                "spacing",
                "7xl"
            ]
        },
        "8xl": {
            "value": "160px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "160px"
            },
            "name": "Spacing8xl",
            "attributes": {
                "category": "spacing",
                "type": "8xl"
            },
            "path": [
                "spacing",
                "8xl"
            ]
        },
        "9xl": {
            "value": "192px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "192px"
            },
            "name": "Spacing9xl",
            "attributes": {
                "category": "spacing",
                "type": "9xl"
            },
            "path": [
                "spacing",
                "9xl"
            ]
        },
        "10xl": {
            "value": "240px",
            "filePath": "src/foundation/figma/spacing.json",
            "isSource": true,
            "original": {
                "value": "240px"
            },
            "name": "Spacing10xl",
            "attributes": {
                "category": "spacing",
                "type": "10xl"
            },
            "path": [
                "spacing",
                "10xl"
            ]
        }
    },
    "font": {
        "family": {
            "display": {
                "value": "'Source Serif Pro', 'Times New Roman', serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "'Source Serif Pro', 'Times New Roman', serif"
                },
                "name": "FontFamilyDisplay",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "display"
                },
                "path": [
                    "font",
                    "family",
                    "display"
                ]
            },
            "mono": {
                "value": "Menlo, Courier, monospace",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "Menlo, Courier, monospace"
                },
                "name": "FontFamilyMono",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "mono"
                },
                "path": [
                    "font",
                    "family",
                    "mono"
                ]
            },
            "sans": {
                "value": "Avenir, sans-serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "Avenir, sans-serif"
                },
                "name": "FontFamilySans",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "sans"
                },
                "path": [
                    "font",
                    "family",
                    "sans"
                ]
            },
            "serif": {
                "value": "'Source Serif Pro', 'Times New Roman', serif",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "'Source Serif Pro', 'Times New Roman', serif"
                },
                "name": "FontFamilySerif",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "serif"
                },
                "path": [
                    "font",
                    "family",
                    "serif"
                ]
            }
        },
        "letterSpacing": {
            "s": {
                "value": "0.25em",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "0.25em"
                },
                "name": "FontLetterSpacingS",
                "attributes": {
                    "category": "font",
                    "type": "letterSpacing",
                    "item": "s"
                },
                "path": [
                    "font",
                    "letterSpacing",
                    "s"
                ]
            },
            "m": {
                "value": "0.35em",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "0.35em"
                },
                "name": "FontLetterSpacingM",
                "attributes": {
                    "category": "font",
                    "type": "letterSpacing",
                    "item": "m"
                },
                "path": [
                    "font",
                    "letterSpacing",
                    "m"
                ]
            }
        },
        "lineHeight": {
            "body": {
                "value": 1.5,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.5
                },
                "name": "FontLineHeightBody",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "body"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "body"
                ]
            },
            "header": {
                "value": 1.125,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.125
                },
                "name": "FontLineHeightHeader",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "header"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "header"
                ]
            },
            "text": {
                "value": 1.2,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 1.2
                },
                "name": "FontLineHeightText",
                "attributes": {
                    "category": "font",
                    "type": "lineHeight",
                    "item": "text"
                },
                "path": [
                    "font",
                    "lineHeight",
                    "text"
                ]
            }
        },
        "size": {
            "2xs": {
                "value": "10px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "10px"
                },
                "name": "FontSize2xs",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "2xs"
                },
                "path": [
                    "font",
                    "size",
                    "2xs"
                ]
            },
            "xs": {
                "value": "12px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "12px"
                },
                "name": "FontSizeXs",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "xs"
                },
                "path": [
                    "font",
                    "size",
                    "xs"
                ]
            },
            "s": {
                "value": "14px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "14px"
                },
                "name": "FontSizeS",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "s"
                },
                "path": [
                    "font",
                    "size",
                    "s"
                ]
            },
            "m": {
                "value": "16px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "16px"
                },
                "name": "FontSizeM",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "m"
                },
                "path": [
                    "font",
                    "size",
                    "m"
                ]
            },
            "l": {
                "value": "20px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "20px"
                },
                "name": "FontSizeL",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "l"
                },
                "path": [
                    "font",
                    "size",
                    "l"
                ]
            },
            "xl": {
                "value": "24px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "24px"
                },
                "name": "FontSizeXl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "xl"
                },
                "path": [
                    "font",
                    "size",
                    "xl"
                ]
            },
            "2xl": {
                "value": "28px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "28px"
                },
                "name": "FontSize2xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "2xl"
                },
                "path": [
                    "font",
                    "size",
                    "2xl"
                ]
            },
            "3xl": {
                "value": "32px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "32px"
                },
                "name": "FontSize3xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "3xl"
                },
                "path": [
                    "font",
                    "size",
                    "3xl"
                ]
            },
            "4xl": {
                "value": "40px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "40px"
                },
                "name": "FontSize4xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "4xl"
                },
                "path": [
                    "font",
                    "size",
                    "4xl"
                ]
            },
            "5xl": {
                "value": "48px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "48px"
                },
                "name": "FontSize5xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "5xl"
                },
                "path": [
                    "font",
                    "size",
                    "5xl"
                ]
            },
            "6xl": {
                "value": "56px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "56px"
                },
                "name": "FontSize6xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "6xl"
                },
                "path": [
                    "font",
                    "size",
                    "6xl"
                ]
            },
            "7xl": {
                "value": "68px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "68px"
                },
                "name": "FontSize7xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "7xl"
                },
                "path": [
                    "font",
                    "size",
                    "7xl"
                ]
            },
            "8xl": {
                "value": "84px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "84px"
                },
                "name": "FontSize8xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "8xl"
                },
                "path": [
                    "font",
                    "size",
                    "8xl"
                ]
            },
            "9xl": {
                "value": "100px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "100px"
                },
                "name": "FontSize9xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "9xl"
                },
                "path": [
                    "font",
                    "size",
                    "9xl"
                ]
            },
            "10xl": {
                "value": "120px",
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": "120px"
                },
                "name": "FontSize10xl",
                "attributes": {
                    "category": "font",
                    "type": "size",
                    "item": "10xl"
                },
                "path": [
                    "font",
                    "size",
                    "10xl"
                ]
            }
        },
        "weight": {
            "thin": {
                "value": 100,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 100
                },
                "name": "FontWeightThin",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "thin"
                },
                "path": [
                    "font",
                    "weight",
                    "thin"
                ]
            },
            "light": {
                "value": 300,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 300
                },
                "name": "FontWeightLight",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "light"
                },
                "path": [
                    "font",
                    "weight",
                    "light"
                ]
            },
            "regular": {
                "value": 400,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 400
                },
                "name": "FontWeightRegular",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "regular"
                },
                "path": [
                    "font",
                    "weight",
                    "regular"
                ]
            },
            "medium": {
                "value": 500,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 500
                },
                "name": "FontWeightMedium",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "medium"
                },
                "path": [
                    "font",
                    "weight",
                    "medium"
                ]
            },
            "semiBold": {
                "value": 600,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 600
                },
                "name": "FontWeightSemiBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "semiBold"
                },
                "path": [
                    "font",
                    "weight",
                    "semiBold"
                ]
            },
            "bold": {
                "value": 700,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 700
                },
                "name": "FontWeightBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "bold"
                },
                "path": [
                    "font",
                    "weight",
                    "bold"
                ]
            },
            "extraBold": {
                "value": 800,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 800
                },
                "name": "FontWeightExtraBold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "extraBold"
                },
                "path": [
                    "font",
                    "weight",
                    "extraBold"
                ]
            },
            "black": {
                "value": 900,
                "filePath": "src/foundation/figma/typography.json",
                "isSource": true,
                "original": {
                    "value": 900
                },
                "name": "FontWeightBlack",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "black"
                },
                "path": [
                    "font",
                    "weight",
                    "black"
                ]
            }
        }
    }
};
//# sourceMappingURL=tokens.js.map